import { fetchCurrentUser } from '../../ducks/user.duck';
import { retrieveSubscriptionPrice } from '../../ducks/stripe.duck';

// ================ Action types ================ //

export const SET_INITIAL_STATE = 'app/ManageSubscriptionPage/SET_INITIAL_STATE';
export const CANCEL_SUBSCRIPTION_REQUEST = 'app/ManageSubscriptionPage/CANCEL_SUBSCRIPTION_REQUEST';
export const CANCEL_SUBSCRIPTION_SUCCESS = 'app/ManageSubscriptionPage/CANCEL_SUBSCRIPTION_SUCCESS';
export const CANCEL_SUBSCRIPTION_ERROR = 'app/ManageSubscriptionPage/CANCEL_SUBSCRIPTION_ERROR';

// ================ Reducer ================ //

const initialState = {
  cancelSubscriptionInProgress: false,
  cancelSubscriptionError: null,
  cancelSubscriptionSuccess: false,
  subscription: null,
};

export default function manageSubscriptionPageReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_INITIAL_STATE:
      return { ...initialState };
    case CANCEL_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        cancelSubscriptionInProgress: true,
        cancelSubscriptionError: null,
        cancelSubscriptionSuccess: false,
      };
    case CANCEL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        cancelSubscriptionInProgress: false,
        cancelSubscriptionError: null,
        cancelSubscriptionSuccess: true,
        subscription: action.payload.subscription,
      };
    case CANCEL_SUBSCRIPTION_ERROR:
      return {
        ...state,
        cancelSubscriptionInProgress: false,
        cancelSubscriptionError: action.payload,
        cancelSubscriptionSuccess: false,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setInitialState = () => ({ type: SET_INITIAL_STATE });

export const cancelSubscriptionRequest = () => ({ type: CANCEL_SUBSCRIPTION_REQUEST });
export const cancelSubscriptionSuccess = (subscription) => ({
  type: CANCEL_SUBSCRIPTION_SUCCESS,
  payload: { subscription },
});
export const cancelSubscriptionError = (error) => ({
  type: CANCEL_SUBSCRIPTION_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ //

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  // Reset page-local state on every load
  dispatch(setInitialState());

  // In parallel: fetch user + subscription prices
  // If either fails, we swallow here so the page still renders and your
  // stripe/user ducks can show their own error states.
  await Promise.allSettled([
    dispatch(fetchCurrentUser()),
    dispatch(retrieveSubscriptionPrice()),
  ]);
};